import React, { useEffect, useState } from 'react';
import {
  Button,
  Divider,
  Dropdown,
  Menu,
  Popconfirm,
  Table,
  Image,
} from 'antd';

import {
  EditOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
  DownOutlined,
  PlusOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as axios from 'axios';
import CustomContent from '../../../components/Content/CustomContent';
import {
  deletePoiGroupsAction,
  getPoiGroupsAction,
} from '../../../actions/AppCms/PoiGroupActions';
import { history } from '../../../utils/history';
import { host } from '../../../utils/config';
import Authorized from '../../../components/Authorization/Authorized';

const PoiGroupList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  const { poiGroups, poiGroupFilterParams } = useSelector(store => ({
    poiGroups: store.poiGroupReducer.poiGroups,
    poiGroupFilterParams: store.filterReducer.poiGroupFilterParams,
  }));

  useEffect(() => {
    dispatch(getPoiGroupsAction(poiGroupFilterParams));
  }, []);

  // const handleSearch = value => {
  //   handleFilterParams({
  //     search: value,
  //     page: 0,
  //   });
  // };

  // const handleFilterParams = filter => {
  //   const newParams = {
  //     ...poiGroupFilterParams,
  //     ...filter,
  //     page: 0,
  //   };
  // //  dispatch( updatePoiGroupFilters(newParams));
  //  dispatch( getPoiGroupsAction(newParams));
  // };

  const handleTableChange = pagination => {


    if (poiGroupFilterParams?.size !== pagination.pageSize) {

      const newParams = {
        ...poiGroupFilterParams,
        size: pagination.pageSize,
        page: 0,
      };
      // dispatch( updatePoiGroupFilters(newParams));
      dispatch(getPoiGroupsAction(newParams));
      return;
    }
    if (poiGroupFilterParams?.page !== pagination.current - 1) {

      const newParams = {
        ...poiGroupFilterParams,
        page: pagination.current - 1,
      };
      // dispatch( updatePoiGroupFilters(newParams));
      dispatch(getPoiGroupsAction(newParams));
    } else {

    }
  };

  const handleAddNew = () => {
    history.push('/add-poi-group');
  };

  const handleMultipleDelete = () => {
    dispatch(deletePoiGroupsAction(selectedRowKeys.join(','))).then(() => {
      setSelectedRowKeys([]);
    });
  };

  const handleSingleDelete = () => {
    dispatch(deletePoiGroupsAction(selectedItem.id)).then(() => {
      setSelectedRowKeys([]);
    });
  };

  const handleMenuClick = action => {
    if (action.key === 'edit') {
      const updatePath = '/updatePoiGroup/' + selectedItem.id;

      history.push(updatePath);
    }
    // if (action.key === 'delete') {
    //   handleSingleDelete();
    // }
  };

  const onSelectChange = selected => {

    setSelectedRowKeys(selected);
  };

  const handleDownload = action => {
    const bearer = localStorage.getItem('userToken');


    let options = {
      url: host + '/api/point-of-interest-groups/export',
      method: 'GET',
      responseType: 'blob', // important
      headers: { Authorization: bearer },
    };
    if (action.key === '1') {
      options = {
        ...options,
        params: {
          all: true,
        },
      };
    } else if (action.key === '2') {
      options = {
        ...options,
        params: {
          idList: selectedRowKeys.join(','),
          all: false,
        },
      };
    }
    axios(options).then(response => {

      const today = new Date();
      const currentDate =
        today.getFullYear() +
        '-' +
        (today.getMonth() + 1) +
        '-' +
        today.getDate();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        'poi-groups-reports-' + currentDate + '.csv',
      );
      document.body.appendChild(link);
      link.click();
    });
  };

  const hasSelected = selectedRowKeys.length > 0;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const menu = (
    <Authorized asset="appcms" operation="write">
      <Menu onClick={handleMenuClick}>
        <Menu.Item key="edit">
          <EditOutlined />
          {t('common.update')}
        </Menu.Item>
        <Menu.Item key="delete">
          <Popconfirm
            title={t('common.sureToDelete')}
            placement="left"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => handleSingleDelete()}
          >
            <DeleteOutlined />
            {t('common.delete')}
          </Popconfirm>
        </Menu.Item>
      </Menu>
    </Authorized>
  );

  const exportMenu = (
    <Menu onClick={handleDownload}>
      <Menu.Item key="1">
        <DownloadOutlined />
        {t('appCms.poiGroup.allPoiGroups')}
      </Menu.Item>
      <Menu.Item key="2" disabled={!hasSelected}>
        <DownloadOutlined />
        {t('appCms.poiGroup.selectedPoiGroups')}
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: t('appCms.poiGroup.image'),
      dataIndex: ['image'],
      key: 'image',
      render: (text, record) => {
        const image = record.image ? (
          <Image width={50} src={record.image.url} />
        ) : (
          ''
        );

        return image;
      },
    },
    {
      title: t('common.title'),
      dataIndex: ['title'],
      key: 'title',
    },
    {
      title: t('appCms.poi.beacon'),
      dataIndex: ['beacon', 'uniqueId'],
      key: 'beacon',
    },
    {
      title: t('common.actions'),
      key: 'action',
      render: () => (
        <span>
          <Dropdown overlay={menu} trigger={['click']}>
            <a className="ant-dropdown-link" href="#">
              {t('common.actions')} <DownOutlined />
            </a>
          </Dropdown>
        </span>
      ),
    },
  ];

  return (
    <CustomContent>
      {/* <Search
          placeholder="Search"
          onSearch={value => handleSearch(value)}
          allowClear
          style={{ float: 'left', width: 300 }}
          defaultValue={poiGroupFilterParams.search}
        /> */}
      <Authorized asset="appcms" operation="write">
        <Button
          icon={<PlusOutlined />}
          type="primary"
          style={{ float: 'right', marginBottom: 16 }}
          onClick={handleAddNew}
        >
          {t('common.add')}
        </Button>
        <Popconfirm
          title={t('common.sureToDelete')}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          onConfirm={() => handleMultipleDelete()}
        >
          <Button
            icon={<DeleteOutlined />}
            disabled={!hasSelected}
            style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
          >
            {t('common.delete')}
          </Button>
        </Popconfirm>
      </Authorized>
      <Dropdown overlay={exportMenu}>
        <Button
          icon={<DownloadOutlined />}
          style={{ float: 'right', marginBottom: 16, marginRight: 16 }}
        >
          {t('appCms.export')}
        </Button>
      </Dropdown>
      <Divider />
      <Table
        columns={columns}
        dataSource={poiGroups}
        rowSelection={rowSelection}
        pagination={{
          // defaultPageSize: poiGroupFilterParams.size,
          // current: poiGroupFilterParams.page + 1,
          total: poiGroups.totalElements,
          showTotal: (total, range) => {
            return t('common.paginationTotal', { start: range[0], end: range[1], total });
          },
          showSizeChanger: true,
          pageSizeOptions: [
            '10',
            '20',
            '30',
            '40',
            '50',
            '100',
            '200',
            '500',
            '1000',
          ],
        }}
        onChange={handleTableChange}
        rowKey={record => record.id}
        onRow={record => {
          return {
            onClick: () => setSelectedItem(record),
          };
        }}
      />
    </CustomContent>
  );
};

export default PoiGroupList;
